import { mapGetters } from 'vuex';

import commentForm from '@/components/helpers/commentForm/index.vue';
import preloader from '@/components/preloader/index.vue';

import Api from '@/utils/api';

import {
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
  ROLE_PROOF_READER,
  DEFAULT_IMAGE,
  ROLE_SYSTEM_ADMIN,
} from '@/utils/const';

export default {
  components: {
    commentForm,
    preloader,
  },
  props: {
    comment: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      defaultImage: DEFAULT_IMAGE,
      editing: false,
      loading: false,

    };
  },
  computed: {
    isAuthor () {
      return this.user == this.comment.AuthorID;
    },
    ...mapGetters({
      user: 'user',
    }),
  },
  methods: {

    /**
         * Remove comment
         */
    removeComment () {
      this.loading = true;

      Api.reports.comments
        .removeComment(this.comment)
        .then((response) => {
          if (response.data.Status) {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'info',
              show: true,
            });

            this.$emit('refresh');
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
          this.loading = false;
        });
    },

    /**
         * Hide edit comment buttons
         */

    showCommentButton (role) {
      switch (role) {
      case ROLE_PROJECT_MNG:
        return true;
      case ROLE_SYSTEM_ADMIN:
        return true;
      case ROLE_PROOF_READER:
        if (this.$store.getters.user.UserId === this.comment.Author) {
          return true;
        } else {
          return false;
        }
      case ROLE_QA_EXPERT:
        if (this.$store.getters.user.UserId === this.comment.Author) {
          return true;
        } else {
          return false;
        }
      }
    },

    /**
         * Show modal dialog
         */
    removeCommentHolder () {
      this.$modal.show('dialog', {
        title: 'Are you sure delete this comment?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.removeComment();
            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },

    /**
         * Toogle between edit and show comment
         */
    toggleEditStatus () {
      this.editing = !this.editing;
    },

    /**
         * Method for change comment
         *
         * @param {String} comment
         */
    changeCommentInput (comment) {
      this.comment.InnerText = comment;
    },

    /**
         * Change comment
         */
    changeComment () {
      this.editing = false;
      this.loading = true;

      Api.reports.comments
        .editComment(this.comment)
        .then((response) => {
          if (response.status == 200) {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'info',
              show: true,
            });

            this.$emit('refresh');
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
          this.loading = false;
        });
    },

  },
};
